export enum CustomerTypeEnum {
  Personal = 'personal',
  Company = 'company',
}
